module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_family_photowedding-3a69d58c6e9d904ba3a90f9c19ceb74f.jpg";